var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcSponsortree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 71",
    d: "M41.856 30.855h-4.143v-9.428a.857.857 0 0 0-.857-.857H22.285v-5.142h4.857a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H15.714a2 2 0 0 0-2 2v11.428a2 2 0 0 0 2 2h4.856v5.142H6a.857.857 0 0 0-.857.857v9.429H1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1H6.857v-8.571H36v8.57h-4.144a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1v-10a1 1 0 0 0-1-1",
    transform: "translate(2.572 2.572)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSponsortree);
export default __webpack_public_path__ + "static/media/ic_sponsortree.63fa9952759ebd6c86f877e50df39854.svg";
export { ForwardRef as ReactComponent };